var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#074673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-397.006 -187.006)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.25,3.25v-1h-5l-8,9,5,5,.733-.747.767.747,7.5-8.5V3.25Zm-8,12.293L2.95,11.25l7.508-8.5H14.75V7.043l-6.768,7.75-.354.355Zm8.5-8-7,8-.412-.4,6.912-7.9V3.75h.5Z",
    transform: "translate(394.756 184.756)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.606,8.963A1.106,1.106,0,1,0,22.5,7.856,1.107,1.107,0,0,0,23.606,8.963Zm0-1.66a.553.553,0,1,1-.553.553A.553.553,0,0,1,23.606,7.3Z",
    transform: "translate(383.346 182.468)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.79087c0c76e6c16f550dbf9ce60033fa.svg";
export { ForwardRef as ReactComponent };